import { QuitusStatus } from '@services';
import { GrFormCheckmark } from 'react-icons/gr';
import { IoIosSend } from 'react-icons/io';
import { RiHourglassFill } from 'react-icons/ri';

export const QuitusStatusProvider = ({ status }: { status: QuitusStatus }) => {
    switch (status) {
        case QuitusStatus.WAITING:
        case QuitusStatus.TRANSMITTED:
            return (
                <div className="quitus-item-created">
                    <RiHourglassFill fontSize={28} color="#B3E0CA" />
                </div>
            );
        case QuitusStatus.TREATED:
            return (
                <div className="quitus-item-created">
                    <IoIosSend fontSize={28} color="#B3E0CA" />
                </div>
            );
        case QuitusStatus.ARCHIVED:
            return (
                <div className="quitus-item-confirmed">
                    <GrFormCheckmark fontSize={28} color="white" />
                </div>
            );
        default:
            return <div className="quitus-item-status">Inconnue</div>;
    }
};
